import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PublicRouteProps {
  children: React.ReactNode;
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const { currentUser } = useAuth();

  if (currentUser) {
    return <Navigate to="/console" replace />;
  }

  return <>{children}</>;
}